// lib
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

// components
import { RadioButton } from 'primereact/radiobutton'

// styles
import style from '@aytm/app/stats/page/sidebar/completes/styles/CompletesPanel.module.scss'

const CompletesPanel = ({ model, disabled, onCompletesChange }) => {
  const { showUnfinished } = model

  const [unfinished, setUnfinished] = useState(showUnfinished)

  useEffect(() => {
    setUnfinished(showUnfinished)
  }, [showUnfinished])

  useEffect(() => {
    onCompletesChange(unfinished)
  }, [unfinished, onCompletesChange])

  return (
    <div className={style.component}>
      <div className={style['component-title']}>Filter By Completes</div>

      <div className={`${style.row} ${style.param} p-fluid${disabled ? '' : ' p-subtheme-contrast'}`}>
        <RadioButton
          value="0"
          checked={!unfinished}
          disabled={disabled}
          onChange={disabled ? null : () => setUnfinished(false)}
        />
        <span
          className={classNames(style['row-label'], { 'p-disabled': disabled })}
          onClick={disabled ? null : () => setUnfinished(false)}
        >
          Show only full
          <br />
          completes
        </span>
      </div>
      <div className={`${style.row} ${style.param} p-fluid${disabled ? '' : ' p-subtheme-contrast'}`}>
        <RadioButton
          value="1"
          checked={unfinished}
          disabled={disabled}
          onChange={disabled ? null : () => setUnfinished(true)}
        />
        <span
          className={classNames(style['row-label'], { 'p-disabled': disabled })}
          onClick={disabled ? null : () => setUnfinished(true)}
        >
          Show all - partial and
          <br />
          full completes
        </span>
      </div>
    </div>
  )
}

CompletesPanel.propTypes = {
  model: PropTypes.object,
  disabled: PropTypes.bool,
  onCompletesChange: PropTypes.func
}

CompletesPanel.displayName = 'CompletesPanel'

export default CompletesPanel
